import { useEffect, useState } from 'react';
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';
import PostRail from '../shared/PostRail';
import { SectionCard } from '../shared/insightUi';

function CommercialPosts({ commercial_posts = [], brandAffinityList, brandPosts }) {
  const [brandCommPosts, setBrandCommPosts] = useState([...commercial_posts]);

  useEffect(() => {
    const newPosts = brandPosts.length > 0 ? brandPosts : commercial_posts;
    // Only update state if the content actually changed
    setBrandCommPosts((prev) => (prev.length === newPosts.length ? prev : [...newPosts]));
  }, [brandPosts, commercial_posts]);

  const posts = brandCommPosts.slice(0, 30);
  if (!posts.length) return null;
  return (
    <SectionCard
      icon={<CampaignRoundedIcon fontSize="small" />}
      title="Commercial posts"
      subtitle="Brand collaborations and sponsored content"
      bodyPadding="16px 24px 12px"
    >
      <PostRail posts={posts} />
    </SectionCard>
  );
}

export default CommercialPosts;
